let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5httq")).then(() => parcelRequire('jaXYa'));